import React from "react";
import LandingPage from "./LandingPage";
import { buyVendingContent } from "../data/landingContent";

export default function BuyVending() {
  return <LandingPage content={buyVendingContent} />;
}
